import { preloadPostOfficePlacementWithSessionContext } from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';

import { fg } from '@confluence/feature-gating';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures';
import {
	type PreloadFnContext,
	waitForAllReturnWhenError,
} from '@confluence/query-preloader-tools';

export const preloadPostOfficeConfluenceSideNav = async (
	preloadedSessionContext: PreloadFnContext,
) => {
	const tasks: Promise<any>[] = [];

	if (preloadedSessionContext.userId && fg('post-office-confluence-side-nav-placement-rollout')) {
		const preloadPostOfficeSideNav = async () => {
			return SSRMeasures.run(
				'ssr-app/prepare/preloadQuery/postOffice:ConfluenceSideNav',
				async () => {
					return preloadPostOfficePlacementWithSessionContext(
						'confluence-side-nav',
						preloadedSessionContext,
					);
				},
			);
		};

		tasks.push(preloadPostOfficeSideNav());
	}

	return waitForAllReturnWhenError(tasks);
};
